import React from 'react';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

const Noop = createReactClass({
  displayName: 'Noop',

  render() {
    return null;
  },
});

const maybeRender = (predicate: (p: any) => boolean) => (
  Component: React.ComponentType<any>,
  FallbackComponent: React.ComponentType<any>
) => {
  FallbackComponent = FallbackComponent || Noop;

  const MaybeRender = (props: any) =>
    predicate(props) ? (
      <Component {...props} />
    ) : (
      <FallbackComponent {...props} />
    );

  MaybeRender.displayName = `maybeRender(${Component.displayName ||
    'UnnamedComponent'})`;
  return MaybeRender;
};

export default maybeRender;
